module.exports = "<app-navigation #appNav></app-navigation>\n<div class=\"main-container container-fluid\" style=\"overflow: auto\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/main-container/main-container.component.html
// module id = ../../../../../src/app/components/main-container/main-container.component.html
// module chunks = main